import Ticker from "framer-motion-ticker";

export function TickerPlaceholder() {
return (
    <Ticker
  duration={60}
  isPlaying={true}
  onMouseEnter={() => {}}
  onMouseLeave={() => {}}
>
   {Array.from({ length: 8 }).map((_, idx) => (
        <div
          key={idx}
          className="w-[250px] h-[80px] mt-2 bg-gray-100 border rounded-lg border-gray-200 me-4 animate-pulse grid grid-col-4 p-3 items-center"
          style={{
            boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)",
          }}
        >
          <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
          <div className="h-4 bg-gray-300 rounded w-1/2"></div>
        </div>
      ))}
</Ticker>

)
}